import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { ReadRetailerNetworkLocations } from '@occc-app/App/PolicyBasedAccessControl/userActions';

import { RetailerNetworkGuard } from '../guards/retailer-network.guard';

type RetailerNetworkMyStoresStorePageGuardProps = {
  children: ReactNode;
};

export const RetailerNetworkMyStoresStorePageGuard = ({
  children,
}: RetailerNetworkMyStoresStorePageGuardProps) => {
  const { networkId = '' } = useParams<{ networkId: string }>();

  return (
    <RetailerNetworkGuard policyWithParams={ReadRetailerNetworkLocations({ uuid: networkId })}>
      {children}
    </RetailerNetworkGuard>
  );
};
